<template>
  <b-container fluid>
    <b-card
      header="매뉴얼"
      style="max-width: 50rem; margin: auto; margin-top: 3vh;"
      class="mb-2"
      align="left"
    >
      <Spinner />
    </b-card>
    <b-button
      class="mr-1"
      v-if="editableUse"
      variant="outline-primary"
      size="sm"
      @click="editModal()"
      >편집</b-button
    >
    <b-button
      class="mr-1"
      v-if="editable"
      variant="outline-primary"
      size="sm"
      @click="saveModal()"
      >저장</b-button
    >
  </b-container>
</template>

<script>
import Spinner from "../components/Spinner";
import { init, conversion, setSnackBarInfo } from "../js/common_function";
import { eventBus } from "../main";

export default {
  name: "Manual",
  components: {
    Edit,
    Spinner,
  },
  data() {
    return {
      perPage: Number(localStorage.getItem("perPage")),
      scrollY: "",
      loading: false,
      selected: [],
      results: [],
      filter: "",
      options: {
        search: true,
        showColumns: true,
      },
      errors: [],
      loginMember: {
        username: "",
        password: "",
      },
      contents: {
        id: "",
        title: "",
        contents: "",
        contentsHTML: "",
        auth: "",
        editable: "",
        editableUse: "",
        isNew: "",
        radioSelectedView: false,
        sort: "",
        replyUse: "",
      },
    };
  },
  computed: {
    modal() {
      return this.$store.state.bulletin.modal;
    },
    editable() {
      return this.$store.getters.isEditable;
    },
    editableUse() {
      return this.$store.getters.isEditableUse;
    },
  },

  methods: {
    editModal() {
      this.setAuth();
      this.$store.commit("EDIT_MODAL");
    },
    saveModal() {
      this.$refs.edit.bulletin_save("viewManual");
    },

    setAuth() {
      this.radioSelected = this.$store.getters.isContentsAuth;
    },

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
      } else {
        // console.log(files.length)
        for (let i = 0; i < files.length; i++) {
          this.createImage(files[i]);
        }
      }
    },
    createImage(file) {
      var edit = this.$refs.edit.editor;
      var reader = new FileReader();
      var img = document.createElement("img");
      if (file.type === "image/gif") {
        reader.onload = (e) => {
          edit.commands.image({
            src: e.tartget.result,
          });
        };
      } else {
        reader.onload = (e) => {
          img.src = e.target.result;

          var canvas = document.createElement("canvas");
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          var MAX_WIDTH = 500;
          var width = img.width;
          var height = img.height;

          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }

          canvas.width = width;
          canvas.height = height;
          var ctx = canvas.getContext("2d");

          ctx.drawImage(img, 0, 0, width, height);

          var dataurl = canvas.toDataURL("image");
          edit.commands.image({
            src: dataurl,
          });
        };
      }

      reader.readAsDataURL(file);
    },

    callAllListApi(searchSet) {
      this.$store.commit("START_SPINNER");
      this.results = [];

      this.$axios({
        url: this.$config.baseBulletinAppURL + "/allBulletinList",
        method: "post",
        data: {
          makeUserName: localStorage.getItem("username"),
          searchSet: searchSet,
          sort: "IT",
          lastLogin: localStorage.getItem("lastLogin"),
        },
        headers: {
          "token-key": localStorage.getItem("token-key"),
        },
      })
        .then((response) => {
          if (response.status === 200) {
            response.data.map(function (value, key) {
              if (value.notice === true) {
                response.data[key].title = "[공지사항] " + value.title;
                response.data[key]._rowVariant = "info";
              }
            });
            this.results = response.data;
            this.$store.commit("END_SPINNER");
          } else {
            this.$store.commit(
              "SET_SNACKBAR",
              setSnackBarInfo("권한이 없습니다.")
            );
            this.$store.commit("END_SPINNER");
          }
        })
        .catch((error) => {
          this.errors.push(error);
          console.log(error);
        });
    },
  },

  created() {
    this.newItems.contents = "";

    eventBus.$on("refreshListTrigger", () => {
      this.$emit("child-event");
      this.$store.commit("END_SPINNER");
      this.$store.commit("CLOSE_MODAL");
    });
    eventBus.$on("setAuth", () => {
      this.setAuth();
    });
    eventBus.$on("setImageMethod", (e) => {
      this.onFileChange(e);
    });
  },
};
</script>
